"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDealFlexibleEnabled = void 0;
exports.default = useSubscriptionListing;
const react_1 = require("react");
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
const Event_1 = __importDefault(require("@react/web/Common/Event/Event"));
const FacebookPixelSearchSubscriptionOffers_1 = __importDefault(require("@react/common/GtmDataLayer/FacebookPixel/FacebookPixelSearchSubscriptionOffers"));
const CarListingOffersFilterMapper_1 = __importDefault(require("@react/web/Listing/Filter/CarListingOffersFilterMapper"));
const FilterFormData_1 = require("@react/web/Listing/Filter/classes/FilterFormData");
const Filter_1 = require("@react/web/Listing/Filter/Filter");
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const CarListingOffersMapper_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/CarListingOffersMapper"));
const ListingOffersList_1 = __importDefault(require("@react/web/Listing/ListingOffersList/ListingOffersList"));
const PageHelper_1 = __importDefault(require("@react/web/Listing/PageHelper/PageHelper"));
const PageUrlHelper_1 = __importDefault(require("@react/web/Listing/PageUrlHelper/PageUrlHelper"));
const SortingByEnum_1 = __importDefault(require("@react/web/Listing/Sorting/SortingByEnum"));
const LocalStorageHandler_1 = __importDefault(require("@react/web/Common/LocalStorage/LocalStorageHandler"));
const LocalStorageKeyEnum_1 = __importDefault(require("@react/web/Common/LocalStorage/LocalStorageKeyEnum"));
exports.isDealFlexibleEnabled = Boolean((_a = document.body.dataset.flex === '1') !== null && _a !== void 0 ? _a : false);
function useSubscriptionListing() {
    const [filterFormData, setFilterFormData] = (0, react_1.useState)(null);
    const [filteredListingOffers, setFilteredListingOffers] = (0, react_1.useState)(null);
    const [noResultListingOffers, setNoResultListingOffers] = (0, react_1.useState)(new ListingOffersList_1.default([]));
    const [originalListingOffers, setOriginalListingOffers] = (0, react_1.useState)(null);
    const [mergedCarListingOffer, setMergedCarListingOffer] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [sortBy, setSortBy] = (0, react_1.useState)(PageUrlHelper_1.default.getSortByFromUrl());
    const [paging, setPaging] = (0, react_1.useState)(PageUrlHelper_1.default.getPageRangeFromUrl());
    const [isSmallScreen, setSmallScreen] = (0, react_1.useState)(ScreenSize_1.default.isSmallScreen());
    const [selectedMakes, setSelectedMakes] = (0, react_1.useState)([]);
    const [selectedModels, setSelectedModels] = (0, react_1.useState)([]);
    const [selectedBodyTypes, setSelectedBodyTypes] = (0, react_1.useState)([]);
    const subscriptionListingHeader = document.getElementById('listing-header');
    const subscriptionListing = document.getElementById('listing-item-offers-list');
    const { filterState } = window;
    const pushListingLoadedEvent = (filteredListingOffersList) => {
        (0, FacebookPixelSearchSubscriptionOffers_1.default)(filteredListingOffersList.listingOffers);
    };
    const updateScreenSize = () => {
        setSmallScreen(ScreenSize_1.default.isSmallScreen());
    };
    const scrollTopSubscriptionListing = () => {
        if (subscriptionListingHeader === null || subscriptionListing === null) {
            return;
        }
        if (isSmallScreen === true) {
            subscriptionListing.scrollIntoView();
        }
        else {
            subscriptionListingHeader.scrollIntoView();
        }
    };
    const scrollToLocalStorageYPosition = () => {
        if (LocalStorageHandler_1.default.hasDataInLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY)) {
            window.scrollTo(0, Number(LocalStorageHandler_1.default.getDataFromLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY)));
        }
    };
    const removeLocalStorageYPosition = () => {
        if (LocalStorageHandler_1.default.hasDataInLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY)) {
            LocalStorageHandler_1.default.removeDataFromLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY);
        }
    };
    const handleMergedOfferClick = (listingOffer, isListingOffersListEmpty) => {
        LocalStorageHandler_1.default.setDataToLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY, String(window.scrollY));
        if (filterFormData && originalListingOffers) {
            setSelectedMakes([...filterFormData.getSelectedMakes()]);
            setSelectedModels([...filterFormData.getSelectedModels()]);
            setSelectedBodyTypes([...filterFormData.getSelectedBodyTypes()]);
            Object.keys(filterFormData).forEach((key) => {
                if (key === FilterStateKeysEnum_1.default.make) {
                    filterFormData.make.forEach((item) => {
                        item.active = item.value === listingOffer.makeSlug;
                    });
                }
                else if (key === FilterStateKeysEnum_1.default.body) {
                    filterFormData.body.forEach((item) => {
                        item.active = item.value === listingOffer.bodyType;
                    });
                }
                else if (key === FilterStateKeysEnum_1.default.model) {
                    filterFormData.model.forEach((item) => {
                        item.active = item.value === listingOffer.modelSlug;
                    });
                }
                else if (isListingOffersListEmpty === true) {
                    filterFormData[key].forEach((item) => {
                        item.active = false;
                    });
                }
            });
            const filteredListingOffersList = (0, Filter_1.filterListingOffers)(originalListingOffers, filterFormData, listingOffer, sortBy, true);
            const mergedOffer = (0, Filter_1.getMergedCarListingOfferByFilterFormData)(originalListingOffers, filterFormData);
            setFilteredListingOffers(filteredListingOffersList);
            setMergedCarListingOffer(mergedOffer);
            pushListingLoadedEvent(filteredListingOffersList);
        }
    };
    const handleSortingChange = (newSortByValue) => {
        if (filteredListingOffers) {
            setPaging([1]);
            setSortBy(newSortByValue);
            setFilteredListingOffers((0, Filter_1.sortOffers)(filteredListingOffers, mergedCarListingOffer !== null, newSortByValue));
            PageUrlHelper_1.default.updateSortInUrl(newSortByValue);
        }
    };
    const handlePagingChange = (currentPages) => {
        if (currentPages.length === 1) {
            PageUrlHelper_1.default.updatePageInUrl(currentPages[0].toString());
        }
        else {
            PageUrlHelper_1.default.updatePageInUrl(`${Math.min(...currentPages)}-${Math.max(...currentPages)}`);
        }
        setPaging(currentPages);
    };
    const handleResetFilterClick = (event) => {
        event.preventDefault();
        if (filterFormData && originalListingOffers) {
            Object.keys(filterFormData).forEach((key) => {
                filterFormData[key].forEach((item) => {
                    item.active = false;
                });
            });
            const filteredOffers = (0, Filter_1.filterListingOffers)(originalListingOffers, filterFormData, null, sortBy, true);
            setFilterFormData(filterFormData);
            setFilteredListingOffers(filteredOffers);
            setMergedCarListingOffer(null);
            pushListingLoadedEvent(filteredOffers);
        }
    };
    const handleResetMergedOfferFilterClick = (event) => {
        event.preventDefault();
        if (filterFormData && originalListingOffers) {
            Object.keys(filterFormData).forEach((key) => {
                if (key === FilterStateKeysEnum_1.default.make) {
                    filterFormData.make.forEach((item) => {
                        item.active = selectedMakes.some((make) => make.value === item.value);
                    });
                }
                if (key === FilterStateKeysEnum_1.default.model) {
                    filterFormData.model.forEach((item) => {
                        item.active = selectedModels.some((model) => model.value === item.value);
                    });
                }
                if (key === FilterStateKeysEnum_1.default.body) {
                    filterFormData.body.forEach((item) => {
                        item.active = selectedBodyTypes.some((bodyType) => bodyType.value === item.value);
                    });
                }
            });
            const filteredOffers = (0, Filter_1.filterListingOffers)(originalListingOffers, filterFormData, null, sortBy, true);
            setFilterFormData(filterFormData);
            setFilteredListingOffers(filteredOffers);
            setMergedCarListingOffer(null);
            pushListingLoadedEvent(filteredOffers);
        }
    };
    const handleFilterChange = (selectedFilterFormData, filterType) => {
        if (filterFormData && originalListingOffers) {
            if (Array.isArray(selectedFilterFormData)) {
                if (filterType === FilterStateKeysEnum_1.default.contractLength) {
                    const selectedItems = selectedFilterFormData.map((item) => item.value);
                    filterFormData.contractLength.forEach((item) => {
                        item.active = selectedItems.includes(item.value);
                    });
                }
            }
            else {
                if (filterType === FilterStateKeysEnum_1.default.mileage
                    || filterType === FilterStateKeysEnum_1.default.inquiryType
                    || filterType === FilterStateKeysEnum_1.default.winterTires) {
                    filterFormData[filterType].forEach((item) => {
                        if (item.value === selectedFilterFormData.value) {
                            item.active = !item.active;
                        }
                        else {
                            item.active = false;
                        }
                    });
                }
                else {
                    filterFormData[filterType].forEach((item) => {
                        if (item.value === selectedFilterFormData.value) {
                            item.active = !item.active;
                        }
                    });
                }
                if (filterType === FilterStateKeysEnum_1.default.make) {
                    filterFormData.model.forEach((item) => {
                        if (item.make === selectedFilterFormData.label) {
                            item.active = false;
                        }
                    });
                }
                if (filterType === FilterStateKeysEnum_1.default.inquiryType) {
                    filterFormData.contractLength.forEach((item) => {
                        item.active = false;
                    });
                }
            }
            const filteredListingOffersList = (0, Filter_1.filterListingOffers)(originalListingOffers, filterFormData, mergedCarListingOffer, sortBy, true);
            setFilterFormData(filterFormData);
            setPaging([1]);
            setFilteredListingOffers(filteredListingOffersList);
            pushListingLoadedEvent(filteredListingOffersList);
        }
    };
    const setListingFromHistory = (filterFormDataFromState) => {
        if (originalListingOffers && filterFormData && filterFormDataFromState !== null) {
            const mappedFilterFormData = new FilterFormData_1.FilterFormData(filterFormDataFromState.mileage, filterFormDataFromState.winterTires, filterFormDataFromState.inquiryType, filterFormDataFromState.contractLength, filterFormDataFromState.make, filterFormDataFromState.model, filterFormDataFromState.body, filterFormDataFromState.fuel, filterFormDataFromState.extra, filterFormDataFromState.equipment, filterFormDataFromState.availability);
            const sortByFromUrl = PageUrlHelper_1.default.getSortByFromUrl();
            const mergedOffer = (0, Filter_1.getMergedCarListingOfferByFilterFormData)(originalListingOffers, mappedFilterFormData);
            const filteredOffers = (0, Filter_1.filterListingOffers)(originalListingOffers, mappedFilterFormData, mergedOffer, sortByFromUrl, false);
            setFilterFormData(mappedFilterFormData);
            setFilteredListingOffers(filteredOffers);
            setMergedCarListingOffer(mergedOffer);
            setSortBy(sortByFromUrl);
            pushListingLoadedEvent(filteredOffers);
        }
    };
    const fetchData = () => {
        try {
            const mappedListingOffers = (0, CarListingOffersMapper_1.default)(filterState.offers);
            const mappedFilterFormData = (0, CarListingOffersFilterMapper_1.default)(filterState);
            const mergedOffer = (0, Filter_1.getMergedCarListingOfferByFilterFormData)(mappedListingOffers, mappedFilterFormData);
            const filteredListingOffersList = (0, Filter_1.filterListingOffers)(mappedListingOffers, mappedFilterFormData, mergedOffer, sortBy, false);
            const noResultListingOffersList = new ListingOffersList_1.default(mappedListingOffers.listingOffers.slice(0, 3));
            PageUrlHelper_1.default.initHistory(mappedFilterFormData, sortBy, paging);
            setOriginalListingOffers(mappedListingOffers);
            setFilterFormData(mappedFilterFormData);
            setFilteredListingOffers(filteredListingOffersList);
            setNoResultListingOffers(noResultListingOffersList);
            setMergedCarListingOffer(mergedOffer);
            setLoading(false);
            pushListingLoadedEvent(filteredListingOffersList);
        }
        catch (e) {
            console.warn(`Catch useSubscriptionListing fetchData error | ${e}`);
            setError(e);
            setLoading(false);
        }
    };
    (0, react_1.useEffect)(() => {
        if (loading === false && filterFormData) {
            const isFilteredOneMakeOnly = filterFormData.getSelectedMakes().length === 1;
            PageHelper_1.default.setMakeDescription(filterFormData, isFilteredOneMakeOnly);
        }
    });
    (0, react_1.useEffect)(() => {
        if (PageUrlHelper_1.default.hasCarDetailBackLinkQueryParam() === false) {
            removeLocalStorageYPosition();
        }
        fetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        if (loading === false && filterFormData && filteredListingOffers) {
            const event = (0, Event_1.default)('ReactListingOffersListLoadedEvent', true, false);
            document.dispatchEvent(event);
            if (paging.length === 1) {
                scrollTopSubscriptionListing();
            }
        }
    }, [paging]);
    (0, react_1.useEffect)(() => {
        if (loading === false && filterFormData && filteredListingOffers) {
            window.onresize = updateScreenSize;
            window.onpopstate = (popStateEvent) => {
                var _a, _b, _c;
                const state = popStateEvent.state;
                setListingFromHistory((_a = state.filterData) !== null && _a !== void 0 ? _a : null);
                setPaging(PageUrlHelper_1.default.getPageRange((_b = state.paging) !== null && _b !== void 0 ? _b : null));
                setSortBy((_c = state.sorting) !== null && _c !== void 0 ? _c : SortingByEnum_1.default.BEST_SELLING);
            };
            if (PageUrlHelper_1.default.hasCarDetailBackLinkQueryParam() === true) {
                scrollToLocalStorageYPosition();
                PageUrlHelper_1.default.removeCarDetailBackUrlParam();
            }
        }
    });
    (0, react_1.useEffect)(() => {
        if (loading === false && filterFormData && filteredListingOffers) {
            const event = (0, Event_1.default)('ReactListingOffersListLoadedEvent', true, false);
            document.dispatchEvent(event);
            scrollTopSubscriptionListing();
        }
    }, [filteredListingOffers]);
    (0, react_1.useEffect)(() => {
        if (loading === false && filterFormData && filteredListingOffers) {
            if (mergedCarListingOffer === null) {
                scrollToLocalStorageYPosition();
            }
            else {
                scrollTopSubscriptionListing();
            }
        }
    }, [mergedCarListingOffer]);
    return {
        filterFormData,
        filteredListingOffers,
        noResultListingOffers,
        sortBy,
        paging,
        handleFilterChange,
        handleSortingChange,
        handlePagingChange,
        handleMergedOfferClick,
        handleResetFilterClick,
        handleResetMergedOfferFilterClick,
        mergedCarListingOffer,
        loading,
        error,
        isSmallScreen,
    };
}
